import { render, staticRenderFns } from "./PasswordBlackList.vue?vue&type=template&id=82412c5a&"
import script from "./PasswordBlackList.vue?vue&type=script&lang=js&"
export * from "./PasswordBlackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports